import gql from 'graphql-tag'

export const GET_IBEACONS = gql`
  query GetIbeacons($filter: GetIbeaconFilter) {
    getIbeacons(filter: $filter) {
      isSuccessful
      errorCode
      errorName
      message
      status
      getIbeacons {
        data {
          ibeaconId
          battery
          name
          vehicle {
            id
            licensePlate
          }
          description
        }
        pagination {
          page
          show
          total
        }
      }
    }
  }
`

export const UPDATE_IBEACON = gql`
  mutation UpdateIbeacon($input: UpdateIbeaconInput) {
    updateIbeacon(input: $input) {
      isSuccessful
      errorCode
      errorName
      message
      status
      updateIbeacon {
        ibeaconId
        battery
        name
        vehicle {
          id
          licensePlate
        }
        description
      }
    }
  }
`
